<template>
  <nav class="px-4 py-4 sm:px-0 sm:py-6 md:py-8 lg:py-10 relative">
    <!-- HEADER TOP -->
    <div class="flex justify-between items-center">
      <!-- LOGO -->
      <div class="flex items-center gap-2">
        <router-link :to="`/portal/home/${encryptFile('iwc')}`">
          <img
            src="@/assets/images/iwc-gazette.svg"
            alt="IWC Logo"
            class="h-12 sm:h-16 md:h-20 lg:h-24 w-auto"
          />
        </router-link>
      </div>

      <!-- USER + MENU -->
      <div class="flex flex-col items-end relative">
        <!-- Logout hidden on mobile -->
        <span
          class="hidden md:flex mb-6 text-sm cursor-pointer items-center"
          @click="logoutHandler()"
        >
          Logout
        </span>

        <!-- User name -->
        <span class="hidden md:inline text-right font-medium">
          {{ $store.state.userLogged }}
        </span>

        <!-- MENU BUTTON -->
        <div class="py-3 flex justify-end items-center gap-4 cursor-pointer">
          <!-- Message with badge -->
          <div class="relative">
            <MessageSvg class="w-7 h-7" />
            <span
              v-if="overallCountBadge"
              class="absolute -top-1 -right-2 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full"
            >
              {{ overallCountBadge }}
            </span>
          </div>

          <!-- Menu -->
          <div @click="$emit('toggle-sidebar'), $emit('menuClick')" class="flex items-center gap-2">
            <MenuSvg />
            <span class="hidden sm:inline font-subheader">Menu</span>
          </div>
        </div>

        <!-- DROPDOWN MENU -->
      </div>
    </div>

    <!-- DATE + VOLUME -->
    <div class="mt-4">
      <hr class="my-2 h-[4px] bg-black border-0" />

      <div
        class="flex justify-between items-center text-xs sm:text-sm md:text-base font-medium text-gray-700"
      >
        <span>{{ currentDateLabel }}</span>
        <span>{{ SemanticVersion }}</span>
      </div>

      <hr class="my-2 h-[3px] bg-black border-0" />
    </div>
  </nav>
</template>
<script>
import encryptHandler from '@/utils/encrypt';
import MenuSvg from '@/components/svgs/MenuSvg.vue';
import MessageSvg from '@/components/svgs/MessageSvg.vue';
import reusableBase from '@/utils/reusables/dateFormat';
import reusableVersion from '@/utils/reusables/version';
import countBadgeHandler from '@/utils/reusables/countBadgeNotif';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

export default {
  components: {
    MenuSvg,
    MessageSvg
  },
  setup() {
    const router = useRouter();
    const { encryptFile } = encryptHandler();
    const { currentDateLabel } = reusableBase();
    const { SemanticVersion } = reusableVersion();
    const { overallCountUnread, overallCountBadge } = countBadgeHandler();
    const menuOpen = ref(false);
    onMounted(() => {
      overallCountUnread();
    });

    const toggleMenu = () => {
      menuOpen.value = !menuOpen.value;
    };
    const renderPassData = (val) => {
      menuOpen.value = val;
    };
    const logoutHandler = () => {
      localStorage.removeItem(process.env.VUE_APP_AUTH_TOKEN);
      router.push('/');
    };

    return {
      currentDateLabel,
      menuOpen,
      toggleMenu,
      renderPassData,
      encryptFile,
      SemanticVersion,
      logoutHandler,
      overallCountUnread,
      overallCountBadge
    };
  }
};
</script>
